import { Link, useLocation } from "react-router-dom";
import { CalendarCheck } from "lucide-react";

export default function StickyMobileCTA() {
  const location = useLocation();
  if (location.pathname === "/booking") return null;
  return (
    <Link
      to="/booking"
      data-testid="sticky-mobile-cta"
      className="md:hidden fixed bottom-5 left-1/2 -translate-x-1/2 z-40 w-[92%] max-w-sm inline-flex items-center justify-center gap-3 rounded-full bg-ink text-bone py-4 text-[11px] tracking-[0.28em] uppercase luxe-shadow"
    >
      <CalendarCheck size={16} strokeWidth={1.5} />
      Онлайн запис
    </Link>
  );
}
